var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAstore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.4708 12.2302C16.4824 11.3486 16.7201 10.4843 17.162 9.7175C17.6039 8.95074 18.2355 8.30652 18.9981 7.84477C18.5137 7.16335 17.8745 6.60257 17.1315 6.20696C16.3885 5.81136 15.5621 5.59183 14.7178 5.56582C12.9169 5.37964 11.1711 6.62713 10.2533 6.62713C9.31787 6.62713 7.90493 5.5843 6.38341 5.61513C5.39926 5.64644 4.44013 5.9283 3.59946 6.43323C2.7588 6.93816 2.06527 7.64894 1.58646 8.49633C-0.487595 12.0329 1.05947 17.2306 3.04628 20.0894C4.04032 21.4892 5.20207 23.0529 6.72222 22.9974C8.20976 22.9367 8.76533 22.0632 10.5609 22.0632C12.3398 22.0632 12.8611 22.9974 14.4121 22.9622C16.0083 22.9367 17.014 21.5561 17.9731 20.143C18.6874 19.1456 19.237 18.0432 19.6016 16.8767C18.6742 16.4904 17.8828 15.8438 17.3261 15.0175C16.7694 14.1913 16.4719 13.2219 16.4708 12.2302Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5403 3.68683C14.4107 2.65787 14.8394 1.3353 14.7356 0C13.406 0.137539 12.1777 0.763404 11.2957 1.75289C10.8644 2.23628 10.5341 2.79865 10.3236 3.40784C10.1131 4.01703 10.0267 4.6611 10.0691 5.30323C10.7342 5.30997 11.3921 5.168 11.9934 4.88801C12.5946 4.60803 13.1236 4.19732 13.5403 3.68683Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAstore);
export default __webpack_public_path__ + "static/media/astore.6092da70a3280bd1ad683f9b0b79266e.svg";
export { ForwardRef as ReactComponent };